import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable, share } from 'rxjs';

@Injectable()
export class DedupeInterceptor implements HttpInterceptor {
  private pendingRequests = new Map<string, Observable<HttpEvent<any>>>();

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const key = this.getRequestKey(req);

    // If request is already pending, return the existing observable
    if (this.pendingRequests.has(key)) {
      return this.pendingRequests.get(key)!;
    }

    // Create new request and cache it
    const request$ = next.handle(req).pipe(
      share(),
      finalize(() => {
        this.pendingRequests.delete(key);
      }),
    );

    this.pendingRequests.set(key, request$);
    return request$;
  }

  private getRequestKey(req: HttpRequest<any>): string {
    // Create unique key based on method + URL + params
    return `${req.method}:${req.urlWithParams}`;
  }
}
